module.exports = __webpack_public_path__ + "static/media/img_Inscription_name2@3x.2c6a28a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_Inscription_name2@3x.png
// module id = 995
// module chunks = 0